<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-26 20:03:19
 * @LastEditTime: 2019-08-15 21:26:44
 * @LastEditors: Please set LastEditors
 -->
<template>
    <div class="container">
        <!-- <el-button type="primary" style="width: 100px;height: 40px;margin-bottom: 20px" class="btnColor" @click="release()">发布公告</el-button> -->
        <el-form ref="form" :model="form" label-width="100px" :inline="true" class="mt20">
            <el-form-item label="添加时间:" style="text-align: center">
                <el-col :span="11">
                    <el-date-picker type="date" placeholder="开始时间" v-model="form.start_time"
                                    style="width: 100%;"></el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                    <el-date-picker type="date" placeholder="结束时间" v-model="form.end_time"
                                    style="width: 100%;"></el-date-picker>
                </el-col>
            </el-form-item>
            <el-form-item label="公告分类:" style="text-align: center">
                <el-col :span="11">
                    <el-select clearable v-model="form.category_id1"  @change="selectCateOne">
                        <el-option v-for=" i in categoryOne" :key="i.id" :label="i.name"
                                   :value="i.id"></el-option>
                    </el-select>

                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                    <el-select clearable v-model="form.category_id2" >
                        <el-option v-for=" i in categoryTwo" :key="i.id" :label="i.name"
                                   :value="i.id"></el-option>
                    </el-select>
                </el-col>
            </el-form-item>
            <el-form-item label="公告标题:">
                <el-input v-model="form.title" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="onSearch()">搜索</el-button>
            </el-form-item>
        </el-form>
        <el-table
                ref="multipleTable"
                :data="tableData"
                border
                stripe
                height="350"
                style="width: 100%"
                @selection-change="handleSelectionChange">
            <!-- <el-table-column
                    type="selection"
                    width="55"
                    fixed>
            </el-table-column>
            <el-table-column
                    label="公告编号"
                    width="80"
                    prop="notice_id"
                    fixed
            > -->
            <!-- </el-table-column> -->
            <el-table-column
                    prop="category_name"
                    label="公告分类"
                    width="180"
                    fixed>
            </el-table-column>
            <el-table-column
                    prop="title"
                    label="公告标题"
                    width="120"
                    show-overflow-tooltip>
            </el-table-column>
            <!-- <el-table-column
                    prop="remarks"
                    label="备注"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="sort"
                    label="排序"
                    width="120"
                    show-overflow-tooltip>
            </el-table-column> -->
            <el-table-column
                    prop="created_at"
                    label="公告时间"
                    show-overflow-tooltip>
            </el-table-column>
            <!-- <el-table-column
                    prop="views"
                    label="浏览"
                    show-overflow-tooltip>
            </el-table-column> -->
            <!-- <el-table-column
                    prop="push_status"
                    label="发布状态"
                    show-overflow-tooltip>
                <template slot-scope="scope">
                   <span v-if="scope.row.push_status == 0">待发布</span>
                   <span v-if="scope.row.push_status == 1">发布中</span>
                   <span v-if="scope.row.push_status == 2">发布完成</span>
                   <span v-if="scope.row.push_status == 3">发布失败</span>
                </template>
            </el-table-column> -->
            <el-table-column
                    fixed="right"
                    prop=""
                    label="操作"
                    width="180"
                    show-overflow-tooltip>
                <template slot-scope="scope">
                    <!-- <el-button type="text" size="small" @click="edit(scope.row.notice_id)">修改</el-button>
                    <el-button type="text" size="small" @click="del(scope.row.notice_id)">删除</el-button> -->
                    <el-button type="text" size="small" @click="check(scope.row.notice_id)">查看</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- <el-button type="primary" style="width: 100px;height: 40px;margin: 20px" @click="delMulti()">
            批量删除
        </el-button> -->
        <!--分页-->
        <el-pagination
                style="margin: 20px 0"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageNo"
                :page-sizes="[20, 50, 100, 200]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalSize">
        </el-pagination>
        <el-dialog
        title="查看"
        :visible.sync="checknotices"
        width="30%"
       >
        <div class='notices'>
                <div class="noticesHead">{{checkData.data.title}}</div>
                <div class="content ql-editor" v-html='checkData.data.content'>

                </div>
        </div>
        </el-dialog>

    </div>
</template>

<script>
    export default {
        name: "announcement-list",
        data() {
            return {
                checknotices:false,// 查看公告弹窗
                checkData:{data:''},//公告详情
                //分页
                pageNo: 1,
                pageSize: 20,
                totalSize: 0,
                categoryOne:[],
                categoryTwo:[],
                form:{
                    start_time:'',
                    end_time:'',
                    title:'',
                    category_id1:'',
                    category_id2:'',
                },
                tableData:[
                ],
                multipleSelection: []
            }
        },
        methods:
            {
                // 查看公告
                check(id){
                   var url='/notices/'+id
                    this.$get('logistics', url, {
                        lang:'',
                     
                    }).then(res => {
                        
                      this.checkData=res
                      this.checknotices=!this.checknotices
                    }).catch(function (error) {
                    
                    });
                },
                // 获取分类
                getCataOne(){
                    this.$get('logistics', '/category.one', {
                        lang:'',
                        type:1
                    }).then(res => {
                        this.categoryOne = res.data;
                    }).catch(function (error) {
                        console.log(error);
                    });
                },
                //选择一级分类
                selectCateOne(val){
                    this.form.category_id1 = val;
                    this.categoryTwo = [];
                    this.form.category_id2 = '';
                    this.getCateTwo();
                },
                getCateTwo(){
                    this.$get('logistics', '/category.two', {
                        lang:'',
                        type:1,
                        pid:this.form.category_id1
                    }).then(res => {
                        this.categoryTwo = res.data;
                    }).catch(function (error) {
                        console.log(error);
                    });
                },
                //列表
                onSearch(){
                    let beginstr = '', endstr = '',cateId = '';
                    if(this.form.start_time){
                        beginstr = this.moment(this.form.start_time).format("YYYY-MM-DD")
                    }
                    if(this.form.end_time){
                        endstr = this.moment(this.form.end_time).format("YYYY-MM-DD");
                    }
                    if(this.form.category_id2){
                        cateId =this.form.category_id2;
                    }else{
                        cateId = this.form.category_id1;
                    }
                    this.$get('logistics' , '/notices', {
                        lang:'',
                        start_time:beginstr,
                        end_time:endstr,
                        category_id:cateId,
                        title:this.form.title,
                        per_page:this.pageSize,
                        page:this.pageNo
                    }).then(res => {
                        this.tableData = res.data;
                        this.totalSize = res.meta.total;
                    }).catch(function (error) {
                        console.log(error);
                    });
                },
                //发布公告
                release(){
                this.$router.push({name:'releaseAnnouncement'});
                },
                edit(id){
                    this.$router.push({name:'releaseAnnouncement',query:{
                            notice_id:id
                        }});
                },
                //删除
                del(id) {
                    this.$confirm('确定要删除吗？可多选批量删除?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        let delArr = [];
                        delArr.push(id);
                        this.$post('logistics', '/notices', {
                            lang:'',
                            _method:'DELETE',
                            notice_id:delArr
                        }).then(res => {
                            this.$message({
                                type: 'success',
                                message: '删除成功'
                            });
                            this.onSearch();

                        }) .catch(error =>{
                            this.$message({
                                type: 'error',
                                message: error.message
                            });

                        });
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        });
                    });

                },
                //批量删除
                delMulti(){
                    if(this.multipleSelection.length == 0){
                        this.$message.error('请勾选数据...');
                        return;
                    }
                    this.$confirm('确定要删除吗？可多选批量删除?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        let delArr = [];
                        for(var i =0; i < this.multipleSelection.length;i++){
                            delArr.push(this.multipleSelection[i].notice_id);
                        }
                        this.$post('logistics', '/notices', {
                            lang:'',
                            _method:'DELETE',
                            notice_id:delArr
                        }).then(res => {
                            this.$message({
                                type: 'success',
                                message: '删除成功'
                            });
                            this.onSearch();

                        }) .catch(error =>{
                            this.$message({
                                type: 'error',
                                message: error.message
                            });

                        });
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        });
                    });
                },
                /*分页*/
                handleSizeChange(val) {
                    this.pageSize = val;
                    this.pageNo = 1;
                    this.onSearch();
                },
                handleCurrentChange(val) {
                    this.pageNo = val;
                    this.onSearch();
                },
                handleSelectionChange(val) {
                    this.multipleSelection = val;
                    //console.log(val);
                }
            },
        created() {
            this.getCataOne();
            this.onSearch();
        },
    }
</script>

<style lang="scss" scoped>
.container{
    height: 100%;
}
.notices{
    padding: 10px;
    .noticesHead{
        font-size: 20px;
        font-weight: 600;
        
        text-align: center;
    }
}
</style>